module.exports = __webpack_public_path__ + "static/jason_edited-5b99d23307f8822b76e5598f8de36dcc.jpg";